import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import queryString from 'querystringify';
import SearchRegular from 'jl-ui-kit/elements/icons/SearchRegular';
import Button from 'jl-ui-kit/elements/button/Button';
import InputWithSubmit from 'jl-ui-kit/elements/input-with-submit/InputWithSubmit';
import styles from './search.scss'; // @TODO tidy these up when removing non-disco search

const loadSearchBoxFiles = _callbackFunction => {
  if (typeof window !== 'undefined') {
    const baseJLUrl =
      window.location.host === 'www.johnlewis.com'
        ? 'https://www.johnlewis.com'
        : 'https://www.integration.project4.com';

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `${baseJLUrl}/search-box-ui/static/index.css`;
    const cssLoaded = new Promise(resolve => {
      link.addEventListener('load', resolve);
    });
    document.head.appendChild(link);

    const script = document.createElement('script');
    const jsLoaded = new Promise(resolve => {
      script.addEventListener('load', resolve);
    });
    script.type = 'text/javascript';
    script.src = `${baseJLUrl}/search-box-ui/static/index.js`;
    document.head.appendChild(script);

    Promise.all([cssLoaded, jsLoaded])
      .then(() => _callbackFunction())
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error('Error loading basic search files ', err);
      });
  } else {
    _callbackFunction();
  }
};

const SubmitButton = () => (
  <Button type="submit">
    <SearchRegular box color="#141414" />
    <span className={styles.visuallyHidden}>Search</span>
  </Button>
);

export const submitFormValidation = (id, box) => e => {
  const input = e.target.elements[id];
  if (input.value === '') {
    e.preventDefault();
    box.current.focus();
  }
};

const Search = ({ id, hideSearch, onFocus }) => {
  const URLQuery =
    typeof window === 'object' && queryString.parse(window.location.search);
  const currentSearch = URLQuery['search-term'] || '';

  const results = useRef(null);
  const container = useRef(null);
  const form = useRef(null);
  const box = useRef(null);
  const [loaded, setLoaded] = useState(null);

  const submitForm = submitFormValidation(id, box);

  return (
    <>
      <div
        className={classNames(styles.form, styles.formContainer, {
          [styles.hide]: hideSearch,
        })}
        data-search-form
        ref={container}
        onFocus={onFocus}
        id="search-container"
      >
        <form
          action="/search"
          className={styles.form}
          ref={form}
          onSubmit={submitForm}
        >
          <label htmlFor={id} className={styles.visuallyHidden}>
            Search
          </label>
          <InputWithSubmit
            type="text"
            name="search-term"
            id={id}
            label="Search"
            placeholder="Search product or brand"
            maxLength={150}
            autoComplete="off"
            defaultValue={currentSearch}
            submitButton={<SubmitButton />}
            extensionProps={{
              role: 'textbox',
              onFocus: () => {
                if (!loaded) {
                  loadSearchBoxFiles(
                    () =>
                      typeof window !== 'undefined' &&
                      window.SearchBoxUI.init(
                        results.current,
                        container.current,
                        form.current,
                        box.current,
                        {}
                      )
                  );
                }
                setLoaded(true);
              },
              ref: box,
            }}
          />
        </form>
        <div ref={results}> </div>
      </div>
    </>
  );
};

Search.defaultProps = {
  hideSearch: false,
};

Search.propTypes = {
  id: PropTypes.string.isRequired,
  hideSearch: PropTypes.bool,
};

export default Search;
